import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { CarHistoryPage } from '@/features/bookings/CarHistory';
import { MobileCarHistory } from '@/features/bookings/mobile/MobileCarHistory';

export const Route = createFileRoute('/_app/car-history')({
  component: CarHistoryRoute,
  validateSearch: (s: Record<string, unknown>) => ({
    vehicleId: typeof s.vehicleId === 'string' ? s.vehicleId : undefined,
    employeeId: typeof s.employeeId === 'string' ? s.employeeId : undefined,
    /* La prenotazione da cui si arriva con «Segnala danno»: serve a registrare da quale viaggio il
       danno è emerso (`vehicle-incident.bookingId`). Senza, quel legame andrebbe ricostruito
       incrociando la data con il calendario. */
    bookingId: typeof s.bookingId === 'string' ? s.bookingId : undefined,
  }),
});

/** Selettore: storico mezzi mobile (MaeDesign) vs pagina desktop. */
function CarHistoryRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileCarHistory /> : <CarHistoryPage />;
}
